import { useQuery } from '@tanstack/react-query';

import { billingClient } from 'api/billing';
import type { OrbCreditLedgerParams } from 'api/types';

import { QueryKeys } from './common';

export const useGetCreditLedger = (params: OrbCreditLedgerParams, options?: { enabled?: boolean }) => {
  return useQuery({
    queryKey: [QueryKeys.getCreditLedger, params],
    queryFn: () => billingClient.getCreditLedger(params),
    refetchOnMount: true,
    staleTime: 1000 * 60,
    enabled: options?.enabled,
  });
};
